import ApiClient from '@afosto/api/ApiClient';

class Twofa {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create a secret / enable 2FA
   *
   * @param {string} type - Type that we look for
   * @param {Object} body - Secret request
   * @param {Object} options - The additional request options
   * @description Create a new secret for 2FA
   * @returns {Promise}
   */
  createSecret(type, body, options = {}) {
    return this.apiClient.request({
      url: `/iam/2fa/secrets/${type}`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Disable 2FA
   *
   * @param {string} type - Type that needs to be deleted
   * @param {Object} options - The additional request options
   * @description Delete the secret and disable 2FA
   * @returns {Promise}
   */
  deleteSecret(type, options = {}) {
    return this.apiClient.request({
      url: `/iam/2fa/secrets/${type}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get secret information
   *
   * @param {string} type - Type that we look for
   * @param {Object} options - The additional request options
   * @description Get the secret for the type for the current user
   * @returns {Promise}
   */
  getSecret(type, options = {}) {
    return this.apiClient.request({
      url: `/iam/2fa/secrets/${type}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Request a backup code over the requested channel
   *
   * @param {string} channel - Channel of choice
   * @param {string} type - Type that we look for
   * @param {Object} options - The additional request options
   * @description Request a otp over the given channel
   * @returns {Promise}
   */
  requestBackup(type, channel, options = {}) {
    return this.apiClient.request({
      url: `/iam/2fa/secrets/${type}/backup/${channel}`,
      method: 'post',
      ...options,
    });
  }

  /**
   * Update a secret
   *
   * @param {string} type - Type that we look for
   * @param {Object} body - Secret request
   * @param {Object} options - The additional request options
   * @description Update an existing secret for 2FA
   * @returns {Promise}
   */
  updateSecret(type, body, options = {}) {
    return this.apiClient.request({
      url: `/iam/2fa/secrets/${type}`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Verify an otp
   *
   * @param {string} type - Type that we look for
   * @param {Object} body - Validation request object
   * @param {Object} options - The additional request options
   * @description Verify if one time password was created with known secret
   * @returns {Promise}
   */
  verifyToken(type, body, options = {}) {
    return this.apiClient.request({
      url: `/iam/2fa/secrets/${type}/verify`,
      method: 'post',
      data: body,
      ...options,
    });
  }
}

export const twofa = new Twofa();

export default Twofa;
